import { TemplateHomeMenuFieldDto } from "@domain/project/template/property/general/homeMenu/template-home-menu-field.dto";
import { Type } from "class-transformer";
import { IsOptional } from "class-validator";

export class TemplateHomeMenuDto {
  @IsOptional()
  @Type(() => TemplateHomeMenuFieldDto)
  newProject?: TemplateHomeMenuFieldDto;
}
